import TrainingSubscription from '../subscription';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSubscription.store(({ trainingId, shareCode }, fetch) => {
    if (shareCode) {
        let formData = new FormData();
        formData.append('share_code', shareCode);
        return fetch.post(`/trainings/subscriptions`, formData);
    }
    return fetch.post(`/trainings/${trainingId}/subscriptions`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
